import { connect } from 'react-redux';

import ExecutionOptionsBar from '../../../components/common/ExecutionOptionsBar';
import { changeAdaptive, toggleAverage, toggleMedian, toggleTrend } from '../../../actions/chart';
import {
  changeRetentionView,
  toggleRetentionAdaptive,
  toggleRetentionAverageLine,
  toggleRetentionMedianLine,
  toggleRetentionTrendLine,
} from '../../../actions/retention/retention';
import { getRetentionOptions } from '../../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  options: getRetentionOptions(state),
  selectStyle: { width: 200 },
  isRetention: true,
});

const mapDispatchToProps = (dispatch) => ({
  onChangeView: (view) => dispatch(changeRetentionView(view)),

  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleRetentionTrendLine())),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleRetentionAverageLine())),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleRetentionMedianLine())),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleRetentionAdaptive())),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionOptionsBar);
